import {useTimeUnitTranslation} from '@aboutyou/i18n';
import {CountdownUnitProps, Text} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const CustomCountdownUnit: React.FC<CountdownUnitProps> = ({
  value,
  unit,
}) => {
  const timeFormat = useTimeUnitTranslation('shorter');

  if (unit === 'seconds') {
    return null;
  }

  return (
    <Wrapper size="px12" color="inherit">
      {value}
      {timeFormat[unit]}
    </Wrapper>
  );
};

const Wrapper = styled(Text)`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  line-height: 1;
`;
